import { SellsFilterParams } from "@/services/sells.service";
import { getDefaultDate } from './dateHelpers';
import { isSameDay } from 'date-fns';
import { FilterParams } from '@/hooks/useSales';

export function addArrayFiltersToParams(
  params: URLSearchParams,
  filterParams?: any
): void {
  if (!filterParams) return;

  Object.entries(filterParams).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const filtered = value.filter((v) => v && v.trim() !== '');
      filtered.forEach((item) => {
        params.append(`${key}[]`, item);
      });
    }
  });
}

export function addStringFiltersToParams(
  params: URLSearchParams,
  filterParams?: Partial<SellsFilterParams>
): void {
  if (!filterParams) return;

  const stringFilters = {
    utm_campaign: filterParams.utm_campaign,
    utm_source: filterParams.utm_source,
    utm_medium: filterParams.utm_medium,
    utm_content: filterParams.utm_content,
    utm_term: filterParams.utm_term,
    src: filterParams.src,
  };

  Object.entries(stringFilters).forEach(([key, value]) => {
    if (typeof value === 'string' && value.trim() !== '') {
      params.append(key, value);
    }
  });
}

export function cleanFilterParams(
  filterParams?: Partial<SellsFilterParams>
): Partial<SellsFilterParams> | undefined {
  if (!filterParams) return undefined;

  const cleaned: Partial<SellsFilterParams> = {};

  const arrayKeys = [
    'status',
    'payment_methods',
    'products',
    'offers',
    'coproducers',
    'affiliates',
  ] as const;

  Object.entries(filterParams).forEach(([key, value]) => {
    if (key === 'invoice_approved' && value === true) {
      cleaned.invoice_approved = true;
      return;
    }
    if (key === 'invoice_not_approved' && value === true) {
      cleaned.invoice_not_approved = true;
      return;
    }
    if (arrayKeys.includes(key as (typeof arrayKeys)[number])) {
      if (Array.isArray(value)) {
        const filtered = value.filter((v) => v && typeof v === 'string' && v.trim() !== '');
        if (filtered.length > 0) {
          (cleaned as Record<string, unknown>)[key] = filtered;
        }
      }
    } else {
      if (typeof value === 'string' && value.trim() !== '') {
        (cleaned as Record<string, unknown>)[key] = value.trim();
      }
    }
  });

  return Object.keys(cleaned).length > 0 ? cleaned : undefined;
}

export const hasActiveFiltersBeyondDates = (
  params: FilterParams,
  fromDate: Date | null,
  toDate: Date | null
): boolean => {
  const hasRealFilters = Object.entries(params).some(([key, value]) => {
    if (key === 'from' || key === 'to' || key === 'q') return false;
    return (
      (Array.isArray(value) && value.length > 0) ||
      (typeof value === 'string' && value !== '')
    );
  });

  if (hasRealFilters) return true;

  if (!fromDate || !toDate) {
    return false;
  }

  const today = getDefaultDate();

  return (
    !isSameDay(fromDate, today) ||
    !isSameDay(toDate, today) ||
    !isSameDay(fromDate, toDate)
  );
};
